export class VendorAuthorityDto {
    constructor(initializer) {
        this.loanRestrict = initializer.loanRestrict;
        this.reservationProhibit = initializer.reservationProhibit;
        this.reservationStatus = initializer.reservationStatus;
        this.vehicleInfo = initializer.vehicleInfo;
    }
}
